import React from "react";

//importing the css
import "../../assets/css/MeetTheTeam.css";

//importing the pictures
import president from "../../assets/img/Excos/president.jpg";
import vicepresident from "../../assets/img/Excos/vicepresident.jpeg";
import pressaffairs from "../../assets/img/Excos/pressaffairs.jpeg";
import pro from "../../assets/img/Excos/pro.jpeg";
import socialdirector from "../../assets/img/Excos/socialdirector.jpeg";
import generalsecretary from "../../assets/img/Excos/generalsecretary.jpeg";
import assistantsportdirector from  "../../assets/img/Excos/assistantsportdirector.jpeg";

function MeetTheTeam() {
    return (
        <div class="responsive-container-block container">
  <div class="responsive-container-block">
    <div class="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
      <div class="card">
        <div class="team-image-wrapper">
          <img class="team-member-image" src={president} />
        </div>
        <p class="text-blk name">
         Joshua Tosin
        </p>
        <p style={{fontWeight: 'bold'}} class="text-blk position">
          PRESIDENT 
        </p>
        <p class="text-blk feature-text">
          I am the president of NASELS and i promise to make things better in the department
        </p>
        <div class="social-icons">
          <a href="https://www.twitter.com" target="_blank">
            <img class="twitter-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg" />
          </a>
          <a href="https://www.facebook.com" target="_blank">
            <img class="facebook-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg" />
          </a>
        </div>
      </div>
    </div>
    <div class="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
      <div class="card">
        <div class="team-image-wrapper">
          <img class="team-member-image" src={vicepresident} />
        </div>
        <p class="text-blk name">
        Asaluwala Anuoluwapo 
        </p>
        <p class="text-blk position">
          VICE PRESIDENT
          
        </p>
        <p class="text-blk feature-text">
         I am loyal to the department and in any way i can i assist the President in doing a good job to benefit the department.
        </p>
        <div class="social-icons">
          <a href="https://www.twitter.com" target="_blank">
            <img class="twitter-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg" /> 
          </a>
          <a href="https://www.facebook.com" target="_blank">
            <img class="facebook-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg" />
          </a>
        </div>
      </div>
    </div>
    <div class="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
      <div class="card">
        <div class="team-image-wrapper">
          <img class="team-member-image" src={pressaffairs}/>
        </div>
        <p class="text-blk name">
          Miracle Patrick
        </p>
        <p  style={{fontWeight: 'bold'}} class="text-blk position">
          DIRECTOR OF PRESS AFFAIRS
        </p>
        <p class="text-blk feature-text">
          I am the social director
        </p>
        <div class="social-icons">
          <a href="https://www.twitter.com" target="_blank">
            <img class="twitter-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg" />
          </a>
          <a href="https://www.facebook.com" target="_blank">
            <img class="facebook-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg" />
          </a>
        </div>
      </div>
    </div>
    <div class="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
      <div class="card">
        <div class="team-image-wrapper">
          <img class="team-member-image" src={pro} />
        </div>
        <p class="text-blk name">
          Eyo Favour
        </p>
        <p style={{fontWeight: 'bold'}} class="text-blk position">
          PUBLIC RELATION OFFICER
        </p>
        <p class="text-blk feature-text">
          I am your public relation officer
        </p>
        <div class="social-icons">
          <a href="https://www.twitter.com" target="_blank">
            <img class="twitter-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg" />
          </a>
          <a href="https://www.facebook.com" target="_blank">
            <img class="facebook-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg" />
          </a>
        </div>
      </div>
    </div>
    <div class="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
      <div class="card">
        <div class="team-image-wrapper">
          <img class="team-member-image" src={socialdirector} />
        </div>
        <p class="text-blk name">
          Ojo Shalom
        </p>
        <p class="text-blk position">
          SOCIAL DIRECTOR
        </p>
        <p class="text-blk feature-text">
          I connect with people and i'm very good in networking with a lot of people that can bring ideas to boost NASELS
        </p>
        <div class="social-icons">
          <a href="https://www.twitter.com" target="_blank">
            <img class="twitter-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg" />
          </a>
          <a href="https://www.facebook.com" target="_blank">
            <img class="facebook-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg" />
          </a>
        </div>
      </div>
    </div>
    <div class="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
      <div class="card">
        <div class="team-image-wrapper">
          <img class="team-member-image" src={generalsecretary} />
        </div>
        <p class="text-blk name">
          Oriola Bukola
        </p>
        <p class="text-blk position">
          GENERAL SECRETARY
        </p>
        <p class="text-blk feature-text">
         I am responsible for writing the minutes of each meeting we have and always taking notes of important details in every moment.
        </p>
        <div class="social-icons">
          <a href="https://www.twitter.com" target="_blank">
            <img class="twitter-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg" />
          </a>
          <a href="https://www.facebook.com" target="_blank">
            <img class="facebook-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg" />
          </a>
        </div>
      </div>
    </div>
    <div class="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
      <div class="card">
        <div class="team-image-wrapper">
          <img class="team-member-image" src={assistantsportdirector} />
        </div>
        <p class="text-blk name">
        Jayeoba Oluwatomisin
        </p>
        <p class="text-blk position">
          Assistant Sports Director
        </p>
        <p class="text-blk feature-text">
          I am the assistant sports director. 
        </p>
        <div class="social-icons">
          <a href="https://www.twitter.com" target="_blank">
            <img class="twitter-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg" />
          </a>
          <a href="https://www.facebook.com" target="_blank">
            <img class="facebook-icon" src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg" />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
    );
}

export default MeetTheTeam;